<template>
	<div class="has-border is-marged-bottom" v-if="blockedCards.length > 0">
		<h3 class="is-3 title is-marginless">{{ translations.title }}</h3>
		<table class="table is-hoverable is-fullwidth is-rowed is-sticky-header is-hidden-mobile" :class="{'is-loading': loader}">
			<thead>
			<tr>
				<th class="is-sortable">
					{{ translations.last_name }}
				</th>
				<th class="is-sortable">
					{{ translations.first_name }}
				</th>
				<th>
					{{ translations.card_number }}
				</th>
				<th>
					{{ translations.contract_status }}
				</th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="card in blockedCards">
				<td>
					<a :href="getRouteForCustomerUser(card.user_id)"
					   data-ta-event="clientarea-track.home.blocked-cards.employee"
					   data-ta-action="Click"
					   data-ta-label="Home-page – Click on Employee’s blocked cards banner"
					   data-ta-page-name="Homepage"
					   :data-ta-payload="JSON.stringify({ 'userId': card.user_id })"
					   class="track-action"
					>
						{{ card.last_name }}
					</a>
				</td>
				<td>{{ card.first_name }}</td>
				<td>{{ card.card }}</td>
				<td v-if="card.contract">{{ translations.status.enabled }}</td>
				<td v-else>{{ translations.status.disabled }}</td>
			</tr>
			<tr v-if="urlNextpage">
				<td colspan="4"><button class="button is-success" @click="nextBlockedCards">{{ translations.more }}</button></td>
			</tr>
			</tbody>
		</table>
		<div class="is-hidden-tablet is-marged-bottom">
			<div class="is-fullwidth has-border-bottom" v-for="card in blockedCards">
				<p class="has-text-weight-bold is-padded-top">
					<a :href="getRouteForCustomerUser(card.user_id)">
						{{ card.first_name }} {{ card.last_name }}
					</a>
				</p>
				<p>
					{{ card.card }}
				</p>
				<p class="is-padded-bottom">
					<span v-if="card.contract">
						{{ translations.status.enabled }}
					</span>
					<span class="icon has-text-danger" v-else>
						{{ translations.status.disabled }}
						<i class="fa-solid fa-square" aria-hidden="true"></i>
					</span>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {ApiMonizze} from '../api-monizze';

	export default {
		props: {
			url: String,
			customerroute: String,
			translations: Object,
			logUrl: {
				type: String,
				required: false
			},
		},
		data ()
		{
			return {
				loader: true,
				blockedCards: [],
				urlNextpage: '',
			}
		},
		mounted() {
			this.urlNextpage = this.url;
			this.nextBlockedCards();
		},
		methods: {
			nextBlockedCards: function()
			{
				if (!this.urlNextpage)
				{
					return;
				}

				this.loader = true;
				const api = new ApiMonizze();
				api.getDataFromApi(
					this.urlNextpage,
					(data, response) => {
						this.urlNextpage = response.links.next;
						this.blockedCards = this.blockedCards.concat(data);
						this.loader = false;
					}
				);
			},
			getRouteForCustomerUser: function(id)
			{
				return this.customerroute.replace(':id', id);
			},
		}
	}
</script>

<style scoped>

</style>
